import themes from 'themes';
import Config from 'config';

const getTheme = () => {
  return themes[Config.PACKAGE_SUFFIX];
};

export default getTheme;
